export default __webpack_public_path__ + "static/preschool11-a327a6d80afbb1d0e341fa01c2d7584d.jpg";